import {Font, StyleSheet} from "@react-pdf/renderer";

Font.register({
    family: 'Montserrat',
    fonts: [
        {src: '/fonts/Montserrat-Regular.ttf', fontWeight: 400},
        {src: '/fonts/Montserrat-Medium.ttf', fontWeight: 500},
        {src: '/fonts/Montserrat-SemiBold.ttf', fontWeight: 600},
        {src: '/fonts/Montserrat-Bold.ttf', fontWeight: 700},
    ],
});

export default StyleSheet.create({
    page: {
        fontFamily: 'Montserrat',
        fontSize: 9,
        padding: 30,
        backgroundColor: '#f5f6f8',
        color: '#121316',
    },
    header: {
        flexDirection: 'row',
        height: 46,
        marginBottom: 15,
        borderRadius: 6,
        overflow: 'hidden',
    },
    headerLeft: {
        flexGrow: 1,
        position: 'relative',
    },
    headerBackground: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    },
    headerTitleContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        paddingLeft: 20,
    },
    headerTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: 'white',
    },
    headerRight: {
        flexShrink: 0,
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'white',
        paddingHorizontal: 20,
    },
    poweredByText: {
        fontSize: 8,
        color: '#026ab4',
        fontWeight: 'semibold',
        marginRight: 8,
    },
    logo: {
        height: 22,
    },
    heroSection: {
        flexDirection: 'row',
        backgroundColor: '#ffffff',
        padding: 12,
        borderRadius: 6,
        border: '1px solid #e0e0e0',
        marginBottom: 15,
        height: 130,
    },
    heroLeft: {
        flex: 1.5,
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    heroRight: {
        flex: 1,
        paddingLeft: 10,
    },
    heroImageWrapper: {
        width: '100%',
        height: '100%',
        borderRadius: 4,
        overflow: 'hidden',
    },
    heroImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    kvItem: {
        width: '50%',
        padding: 4,
    },
    kvLabel: {
        fontSize: 7,
        color: '#5e6b7a',
        textTransform: 'uppercase',
    },
    kvValue: {
        fontSize: 10,
        fontWeight: 'semibold',
    },
    summaryGrid: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginBottom: 15,
    },
    summaryCard: {
        width: '32%',
        margin: '0.66%',
        padding: 10,
        borderRadius: 6,
        textAlign: 'center',
        fontWeight: 'bold',
        marginBottom: 8,
    },
    summaryPass: { backgroundColor: '#e8f5e9', color: '#1b5e20', border: '1px solid #a5d6a7' },
    summaryFail: { backgroundColor: '#fdecea', color: '#7a1e1e', border: '1px solid #f5c2c7' },
    section: {
        backgroundColor: '#ffffff',
        padding: 12,
        borderRadius: 6,
        border: '1px solid #e0e0e0',
        marginBottom: 15,
        wrap: false
    },
    sectionTitle: {
        fontSize: 12,
        fontWeight: 'bold',
        color: '#0e67c2',
        marginBottom: 10,
    },
    sectionBody: {
        flexDirection: 'row',
    },
    checklistContainer: {
        flex: 1.2,
        paddingLeft: 10,
    },
    checklistItem: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        paddingVertical: 5,
        borderBottom: '1px solid #f0f0f0',
        wrap: false
    },
    icon: {
        width: 12,
        height: 12,
        marginRight: 8,
        marginTop: 2,
        flexShrink: 0
    },
    checklistItemContent: {
        flex: 1,
    },
    checklistItemHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 1
    },
    questionText: {
        fontWeight: 'bold',
        flex: 1,
    },
    failChip: {
        backgroundColor: '#d32f2f',
        color: 'white',
        fontSize: 7,
        paddingHorizontal: 5,
        paddingVertical: 1,
        borderRadius: 8,
    },
    answerText: {
        fontSize: 10,
        color: '#1565c0',
        marginTop: 2,
    },
    answerTextFail: {
        color: '#d32f2f',
    },
    imagesContainer: {
        flex: 1.8,
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    generalImagesContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    imageWrapper: {
        width: '50%',
        padding: 4,
        wrap: false,
    },
    generalImageWrapper: {
        width: '33.3%',
        padding: 4,
        wrap: false,
    },
    image: {
        width: '100%',
        height: 80,
        objectFit: 'cover',
        borderRadius: 4,
    },
    imageCaption: {
        fontSize: 7,
        textAlign: 'center',
        marginTop: 2,
        color: '#121316',
    }
});